import { Button, Typography } from '@tino-frontend/coreui'
import { StatusIlustrationDeclineIllustration } from '@tino-frontend/icons'
import { DefaultBrandMarkPositiveLogo } from '@tino-frontend/logos'

import { Container, Content, Title } from './error.styles'

export function Error() {
  const onReload = () => {
    window.location.href = '/'
  }

  return (
    <Container id="pwa-cache-control">
      <Content>
        <DefaultBrandMarkPositiveLogo sx={{ width: 56, height: 24 }} />
        <StatusIlustrationDeclineIllustration
          sx={{ width: 296, height: 180 }}
        />
        <Title>Erro ao carregar os dados da página</Title>
        <Typography mb={5}>
          Não foi possível carregar essa página, pois um novo conteúdo está
          disponível.
        </Typography>
        <Button
          fullWidth
          onClick={onReload}
          variant="contained"
          id="pwa-cache-reload"
        >
          Recarregar página
        </Button>
      </Content>
    </Container>
  )
}
